import React, {useRef, useEffect} from 'react';
import {Box, ToggleButton, ToggleButtonGroup, Typography} from '@mui/material';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatHeaderHashtagIcon from '@mui/icons-material/Title';

interface RichTextEditorProps {
    value: string;
    onChange: (html: string) => void;
    label: string;
}

const RichTextEditor = ({value, onChange, label}: RichTextEditorProps) => {
    const editorRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (editorRef.current && editorRef.current.innerHTML !== value) {
            editorRef.current.innerHTML = value || '';
        }
    }, [value]);

    const execCommand = (command: string, value?: string) => {
        document.execCommand(command, false, value);
        if (editorRef.current) {
            onChange(editorRef.current.innerHTML);
        }
    };

    return (
        <Box sx={{mt: 2, border: '1px solid rgba(0, 0, 0, 0.23)', borderRadius: 1, p: 1, '&:hover': {borderColor: 'rgba(0, 0, 0, 0.87)'}}}>
            <Typography variant="caption" sx={{color: 'text.secondary', ml: 1}}>{label}</Typography>
            <ToggleButtonGroup size="small" sx={{mb: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5, border: 'none'}}>
                <ToggleButton value="bold" onClick={() => execCommand('bold')} title="Kalın">
                    <FormatBoldIcon fontSize="small" />
                </ToggleButton>
                <ToggleButton value="italic" onClick={() => execCommand('italic')} title="İtalik">
                    <FormatItalicIcon fontSize="small" />
                </ToggleButton>
                <ToggleButton value="h3" onClick={() => execCommand('formatBlock', '<h3>')} title="Başlık">
                    <FormatHeaderHashtagIcon fontSize="small" />
                </ToggleButton>
                <ToggleButton value="list" onClick={() => execCommand('insertUnorderedList')} title="Liste">
                    <FormatListBulletedIcon fontSize="small" />
                </ToggleButton>
            </ToggleButtonGroup>
            
            <Box
                ref={editorRef}
                contentEditable
                onInput={() => editorRef.current && onChange(editorRef.current.innerHTML)}
                sx={{
                    minHeight: '100px',
                    outline: 'none',
                    p: 1,
                    borderTop: '1px solid #eee',
                    '& h3': { m: 0, fontSize: '1.1rem', fontWeight: 'bold' },
                    '& ul': { pl: 2 }
                }}
            />
        </Box>
    );
};

export default RichTextEditor;
